import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=7baadd2a&scoped=true"
import script from "./taskDetail.vue?vue&type=script&lang=js"
export * from "./taskDetail.vue?vue&type=script&lang=js"
import style0 from "./taskDetail.vue?vue&type=style&index=0&id=7baadd2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baadd2a",
  null
  
)

export default component.exports